import { defineComponent, PropType } from "vue";
import { Link } from "@/interfaces/Link";

export default defineComponent({
  props: {
    address: String,
    phonelink: String,
    phone: String,
    email: String,
    linkColumn1: { type: Array as PropType<Link[]>, required: true },
    linkColumn2: { type: Array as PropType<Link[]>, required: true },
    socialmedia: { type: Object, required: false },
  },
});
